<template>
  <div class="UserSettingsView animated fadeIn">
    <MuiGridContainer>
      <div class="row">
        <div class="col-12">
          <MuiCard
            :bg="false"
            :border="false"
            :padding-left="false"
            :padding-right="false"
            :padding-bottom="false"
            :padding-top="false"
            size="m"
            class="mx-auto"
          >
            <h1 class="py-6 font-semibold font-xl">
              User settings
            </h1>

            <MuiCardAlert
              v-if="settingsStatus.LOADED"
              class="pb-3"
              type="success"
              full-width
            >
              Profile updated.
            </MuiCardAlert>

            <MuiForm
              ref="form"
              v-model="formData"
              @submit.native="() => updateUserAccount()"
            >
              <div class="pb-1">
                <MuiInputText
                  :placeholder="userAccount.firstName"
                  full-width
                  disabled
                  name="user_first_name"
                  label="First Name"
                />
              </div>
              <div class="pb-1">
                <MuiInputText
                  :placeholder="userAccount.lastName"
                  full-width
                  disabled
                  name="user_last_name"
                  label="Last name"
                />
              </div>
              <div class="pb-1">
                <MuiInputText
                  full-width
                  disabled
                  type="password"
                  name="user_password"
                  label="Password"
                  class="mb-0"
                />
              </div>
              <div class="pt-1 mb-3">
                <a
                  class="link link--main link-hover"
                  @click="showModalPassword"
                >
                  Change password
                </a>
              </div>

              <div
                :class="[
                  'pt-3',
                  'pb-1',
                  'd-flex',
                  'justify-content-end',
                ]"
              />

              <MuiInputPhone
                v-if="userAccount.phone"
                v-model="userAccount.phone"
                :country-label="$t('Views.company_signup.fields.country_phone')"
                :label="$t('Views.company_signup.fields.phone')"
                :phone-label-class="$t('Views.company_signup.fields.phone')"
                :custom-error-messages="{
                  empty: this.$t('Views.company_signup.errors.mandatory'),
                  invalidNumber: $t('Views.company_signup.errors.invalid_phonenumber')
                }"
                mask
                required
                name="phoneNumber"
                default-country="es"
              />

              <MuiButtonFlat
                :is-loading="settingsStatus.LOADING"
                :disabled="settingsStatus.LOADING || !formData.valid"
                submit
              >
                Save changes
              </MuiButtonFlat>
            </MuiForm>
          </MuiCard>
        </div>
      </div>
    </MuiGridContainer>
  </div>
</template>

<script>

import {
  mapState,
  mapActions,
  mapMutations,
} from 'vuex';

import {
  MuiCard,
  MuiInputText,
  MuiForm,
  MuiCardAlert,
  MuiInputPhone,
  MuiButtonFlat,
  MuiGridContainer,
} from '@ubeeqo/motion-ui';
import MAIN_VIEW_MODEL from '@/views/MAIN_VIEW_MODEL';
import UserSettingsView from '.'; // eslint-disable-line import/no-cycle

const modalPassword = 'PasswordModal';

export default {
  name: 'UserSettingsView',
  components: {
    MuiGridContainer,
    MuiCard,
    MuiInputText,
    MuiForm,
    MuiCardAlert,
    MuiInputPhone,
    MuiButtonFlat,
  },
  data() {
    return {
      formData: {},
    };
  },
  computed: {
    ...mapState(MAIN_VIEW_MODEL.userAccount, {
      userAccount: state => state.data,
      uuid: state => state.uuid,
    }),
    ...mapState(MAIN_VIEW_MODEL.userSettings, {
      settingsStatus: state => state.STATUS,
    }),
    getComponentPassword() {
      return {
        component: () => UserSettingsView,
      };
    },
  },
  methods: {
    ...mapActions(MAIN_VIEW_MODEL.userSettings, [
      'setUserPassword',
      'updateUserBusinessProfilePhone',
    ]),
    ...mapMutations(MAIN_VIEW_MODEL.userSettings, {
      clearPasswords: 'clearPasswords',
    }),
    showModalPassword() {
      this.$modal.show(modalPassword, {
        content: this.getComponentPassword,
        title: 'Change password',
        headerBgColor: 'secondary',
        newHeader: true,
        headerCrossBgColor: 'secondary',
        closeButton: false,
        cancelButton: {
          text: 'Cancel',
          action: this.closeModalPassword,
          type: 'ink',
        },
        acceptButton: {
          text: 'SEND',
          action: this.acceptModalPassword,
          type: 'main',
        },
        size: 'small',
      });
    },
    closeModalPassword() {
      this.$modal.close(modalPassword);
      this.clearPasswords();
    },
    async acceptModalPassword() {
      await this.setUserPassword(this.userAccount.uuid);
      if (this.settingsStatus.LOADED) {
        this.closeModalPassword();
      }
    },
    updateUserAccount() {
      const notificationChannelUuid = this.userAccount.profiles
        .find(profile => profile.type === 'business').notifications
        .find(notification => notification.type === 'phone').uuid;

      const parameters = {
        notificationChannelUuid,
        phone: this.userAccount.phone,
      };
      this.updateUserBusinessProfilePhone(parameters);
    },
  },
};
</script>
